import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import PrevDataContext from '../Context/PrevDataContext';

export default function Repl({ filename, roomId, language, time,username }) {
    const navigator = useNavigate();
    const {deleteFile} = useContext(PrevDataContext);

    function handleOnClick(){
        navigator(`/editor/${roomId}`, {
            state: {
              username : localStorage.getItem("username")
            }
          })
    }
    const handleDeleteClick =async()=>{
        const result = await deleteFile(roomId)
    } 
    console.log(language)
    const languages = {
        java:"https://symbols.getvecta.com/stencil_25/40_java.bc46b9254c.svg",
        cpp:"https://isocpp.org/assets/images/cpp_logo.png",
        c:"https://isocpp.org/assets/images/cpp_logo.png",
        js:"https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/600px-JavaScript-logo.png?20120221235433",
        go:"https://go.dev/blog/go-brand/logos.jpg",
        python:"https://symbols.getvecta.com/stencil_25/69_python.34cfd522d6.svg"
    }

    return (
        <div className='repl'>
            {/* <div className="repl-top"> */}
            <div className="left">
                <img src={languages[language]} alt="" />
            </div>
            <div className="right " onClick={handleOnClick}>
                <div className="right-content">
                    <h1>{filename}</h1>
                    <p>{username}</p>
                </div>
                <div className="date">      
                    <p>{new Date(time).toDateString()}</p>
                </div>
            </div>
        <div className="delete">
        <i className="fa-solid fa-trash" onClick={handleDeleteClick}></i>
        </div>
        </div>
    )
}
